<template>
  <div>
    <footer>
      <div class="inner container">
        <p>
          당근중국어 원격평생교육시설<br />(주)캐럿솔루션즈<br
            class="br-pc-off"
          />
          서울특별시 서초구 강남대로 479 신논현타워 6F 06541
          <br class="br-pc-off" />
          <span @click="goSite('https://www.carrotenglish.kr/phone/privacy')"
            >개인정보처리방침</span
          >ㆍ<span @click="goSite('https://www.carrotenglish.kr/phone/terms')"
            >회원약관</span
          ><br />대표이사 이은경<br class="br-pc-off" />
          Copyright ⓒCARROT Solutions Inc. All rights reserved.<br />사업자
          등록번호 357-87-02040
          <span
            @click="
              goSite('https://www.ftc.go.kr/bizCommPop.do?wrkr_no=3578702040')
            "
            >사업자등록번호확인</span
          ><br class="br-pc-off" />
          통신판매업 신고번호 제 2021-서울강남-05384호<br class="br-pc-off" />
          대표번호 : 02-518-0036<br />이메일 helpcarrot@carrotglobal.com<br
            class="br-pc-off"
          />
          호스팅제공자 : (주)엘지유플러스 KIDC<br class="br-pc-off" />
          개인정보관리책임자 김범진
        </p>
        <div>
          <ul>
            <li class="top">
              <p
                class="cursor"
                @click="goSite('https://www.carrotenglish.kr/phone/bbs_notice')"
              >
                공지사항
              </p>
              <p>·</p>
              <p
                class="cursor"
                @click="goSite('https://www.carrotenglish.kr/phone/bbs_event')"
              >
                이벤트
              </p>
              <p>·</p>
              <p
                class="cursor"
                @click="
                  goSite('https://www.carrotenglish.kr/phone/register_payment')
                "
              >
                결제서비스
              </p>
              <p>·</p>
              <p
                class="cursor"
                @click="goSite('https://www.carrotenglish.kr/phone/faq')"
              >
                FAQ
              </p>
            </li>
            <li class="bottom">
              <p>FOLLOW US :</p>
              <ul>
                <li
                  @click="
                    goSite('https://www.instagram.com/carrotenglish/?hl=ko')
                  "
                >
                  <img src="@/assets/img/chinese/footer/insta.png" alt="icon" />
                </li>
                <li @click="goSite('https://blog.naver.com/carrotkr6404')">
                  <img src="@/assets/img/chinese/footer/blog.png" alt="icon" />
                </li>
                <li @click="goSite('https://www.youtube.com/@carrotenglish')">
                  <img
                    src="@/assets/img/chinese/footer/youtube.png"
                    alt="icon"
                  />
                </li>
              </ul>
            </li>
          </ul>
          <div class="select">
            <select @change="changeSelectBox" v-model="site">
              <option value="">Family Site</option>
              <option value="https://www.carrotglobal.com">Carrot HUB</option>
              <option value="https://www.carrotenglish.com">
                당근영어:모바일 화상
              </option>
              <option value="https://gosiliconvalley.co.kr/">
                실리콘밸리 리더십코스
              </option>
              <option value="https://www.expatcare.co.kr/">
                리:로케이션 서비스
              </option>
              <option value="https://biz.carrotenglish.com/edu-tech">
                온라인ºAI과정
              </option>
              <option value="https://www.how-writing.com/how_intro">
                HOW Writing
              </option>
              <option value="http://www.thespac.net/new/">SPAC</option>
              <option value="http://www.thegcat.com/">
                gCAT 글로벌역량진단
              </option>
            </select>
          </div>
        </div>
      </div>
    </footer>
    <!-- Google Tag Manager (noscript) -->
    <noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KLVFDPT6" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  setup() {
    const changeSelectBox = () => {
      if (site.value) {
        window.open(site.value, "_blank");
      }
    };
    const site = ref("");

    const goSite = (url) => {
      window.open(url, "_blank");
    };

    return {
      changeSelectBox,
      site,
      goSite,
    };
  },
};
</script>
<style lang="scss" scoped>
img,
select,
option {
  display: block;
  width: 100%;
}

img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

select {
  position: relative;
  appearance: auto;
  -webkit-appearance: auto;
  -moz-appearance: auto;
  width: 183px;
  font-size: 13px;
  color: #9fa3aa;
  border: 1px solid #9fa3aa;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;

  @media screen and (min-width: 1050px) {
    font-size: 16px;
    padding: 10px 14px;
  }
}

.container {
  max-width: calc(100% - 40px);
  margin: 0 auto;

  @media screen and (min-width: 1050px) {
    max-width: 1000px;
  }
}

.br-pc-off {
  @media screen and (min-width: 1050px) {
    display: none;
  }
}

footer {
  background-color: #26292a;
  padding: 55px 0 85px;

  @media screen and (min-width: 1050px) {
    padding: 62px 0 64px;
  }

  .inner {
    display: flex;
    flex-direction: column;
    gap: 30px;

    @media screen and (min-width: 1050px) {
      gap: 55px;
    }

    > p {
      font-size: 13px;
      color: #9fa3aa;
      line-height: 22px;

      @media screen and (min-width: 1050px) {
        font-size: 14px;
        line-height: 28px;
      }

      span {
        cursor: pointer;
      }
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: 26px;

      @media screen and (min-width: 1050px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      > ul {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .top {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 13px;
          color: #e5e7eb;

          @media screen and (min-width: 1050px) {
            font-size: 16px;
          }

          .cursor {
            cursor: pointer;
          }
        }

        .bottom {
          display: flex;
          align-items: center;
          gap: 5px;

          p {
            font-size: 13px;
            color: #e5e7eb;

            @media screen and (min-width: 1050px) {
              font-size: 16px;
            }
          }

          ul {
            display: flex;
            gap: 10px;

            li {
              width: 22px;
              cursor: pointer;

              @media screen and (min-width: 1050px) {
                width: 26px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
